import { isEmpty } from "lodash";
import { Tenant } from "./Constants";

const {
	JAZZCASH,
	PCI_BOTTLER,
	BAT_KHI,
	ISMAIL_INDUSTRIES,
	BAT_UK,
	PG_PHL,
	BAT_UK_INDEPENDENT,
	LOREAL,
	nielsen_demo,
	BAT_ORGANIZED,
	BAT_GERMANY,
	BAT_TENNESSEE,
	BAT_CZECH,
	BAT_ROMANIA,
	BAT_INDONESIA_RTM,
	BAT_SOUTH_KOREA,
	BAT_ROMANIA_V2,
	BAT_SWITZERLAND,
	BAT_AUSTRIA,
	BAT_SWEDEN,
	BAT_CROATIA,
	BAT_TURKEY,
	BAT_MALAYSIA,
	BAT_UKRAINE,
	BAT_BULGARIA,
	BAT_BRAZIL,
	BAT_SPAIN,
	BAT_FRANCE,
	BAT_FLORIDA,
	BAT_POLAND,
	BAT_NAIROBI,
	BAT_JAPAN,
	BAT_GREECE,
	BAT_KSA,
	BAT_CHILE,
	BAT_ARGENTINA,
	BAT_STATES
} = Tenant;

const CommonSec = ["A", "B", "C", "D"];

const commonClientMarkerFields = ["_id", "code", "name", "location.coordinates", "area"];
const commonCensusMarkerFields = [
	"_id",
	"shop_details.name",
	"shop_details.coordinates",
	"shop_details.street_address",
	"shop_details.nearby_landmark"
];
const extraCensusMarkerFields = {
	[PCI_BOTTLER]: ["shop_data.satellite_sec"],
	[BAT_UK]: ["shop_data.sub_category"],
	[BAT_UK_INDEPENDENT]: ["shop_data.sub_category", "shop_data.facia_url", "shop_data.census_id"],
	[BAT_ORGANIZED]: ["shop_data.sub_category", "shop_data.facia_url", "shop_data.census_id"],
	[BAT_GERMANY]: ["shop_data.sub_type", "shop_data.facia_url"],
	[PG_PHL]: ["shop_details.outlet_types"],
	[LOREAL]: ["shop_data.validated"],
	[BAT_TENNESSEE]: [
		"shop_data.outlet_type",
		"shop_data.census_id",
		"shop_data.shops_matched",
		"shop_data.business_status"
	],
	[BAT_CZECH]: ["shop_data.primarytypedisplayname", "shop_data.census_id"],
	[BAT_INDONESIA_RTM]: ["shop_data.primarytypedisplayname"],
	[BAT_ROMANIA_V2]: ["shop_data.primarytypedisplayname", "shop_data.census_id"],
	[BAT_SWITZERLAND]: ["shop_data.census_id"],
	[BAT_AUSTRIA]: ["shop_data.census_id"],
	[BAT_SWEDEN]: ["shop_data.census_id", "shop_data.shop_matched"],
	[BAT_CROATIA]: ["shop_data.census_id", "shop_data.shop_matched"],
	[BAT_TURKEY]: ["shop_data.census_id", "shop_data.shop_matched"],
	[BAT_MALAYSIA]: ["shop_data.shop_matched", "shop_data.census_id"],
	[BAT_UKRAINE]: ["shop_data.census_id"],
	[BAT_BULGARIA]: ["shop_data.census_id"],
	[BAT_BRAZIL]: ["shop_data.census_id"],
	[BAT_SPAIN]: ["shop_data.census_id"],
	[BAT_FRANCE]: ["shop_data.census_id"],

	[BAT_FLORIDA]: ["shop_data.census_id", "shop_data.shops_matched"],
	[BAT_POLAND]: ["shop_data.census_id"],
	[BAT_NAIROBI]: ["shop_data.census_id"],
	[BAT_JAPAN]: ["shop_data.census_id", "shop_data.smoking_area", "shop_data.horeca"],
	[BAT_GREECE]: ["shop_data.census_id", "shop_data.shop_matched"],
	[BAT_KSA]: ["shop_data.census_id"],
	[BAT_CHILE]: ["shop_data.census_id"],
	[BAT_ARGENTINA]: ["shop_data.census_id"],
	[BAT_STATES]: ["shop_data.census_id", "shop_data.shops_matched"]
};
const extraClientMarkerFields = {
	[JAZZCASH]: ["MERCHANT"],
	[BAT_UK_INDEPENDENT]: ["outlet_data.ownership_type"],
	[LOREAL]: ["outlet_data.new_poi"],
	[BAT_CZECH]: ["outlet_data.channel"],
	[BAT_ROMANIA]: ["outlet_data.channel", "outlet_data.census_id"],
	[BAT_INDONESIA_RTM]: ["outlet_data.channel"],
	[BAT_SOUTH_KOREA]: ["outlet_data.primarytypedisplayname"],

	[BAT_ROMANIA_V2]: ["outlet_data.primarytypedisplayname"],
	[BAT_SWITZERLAND]: ["outlet_data.census_id"],
	[BAT_SWEDEN]: ["outlet_data.census_id"],
	[BAT_TURKEY]: ["code"],
	[BAT_SPAIN]: ["outlet_data.census_id"],
	[BAT_FRANCE]: ["outlet_data.census_id"],
	[BAT_FLORIDA]: ["outlet_data.census_id"],
	[BAT_POLAND]: ["outlet_data.census_id"],
	[BAT_GREECE]: ["outlet_data.census_id"],
	[BAT_KSA]: ["outlet_data.census_id"],
	[BAT_CHILE]: ["outlet_data.census_id"],
	[BAT_ARGENTINA]: ["outlet_data.census_id"],
	[BAT_STATES]: ["outlet_data.census_id"],
	[BAT_BULGARIA]: ["outlet_data.census_id"]
};
export const keysMapping = {
	code: "Census ID",
	"shop_data.business_status": "business_status",
	"shop_data.shop_matched": "shop_matched",
	"shop_data.shops_matched": "shop_matched",
	"outlet_data.census_id": "Census ID",
	"outlet_data.primarytypedisplayname": "Channel Type",
	"shop_data.primarytypedisplayname": "Channel Type",
	"shop_data.census_id": "Census ID",
	"outlet_data.channel": "Channel Type",
	"shop_data.client_id": "BAT ID",
	"BAT_UK_INDEPENDENT.country_id": "Country Name",
	"BAT_UK_INDEPENDENT.region_id": "Region Name",
	"BAT_UK_INDEPENDENT.area_id": "Area Name",
	"BAT_UK_INDEPENDENT.territory_id": "Territory Name",
	"BAT_ORGANIZED.region_id": "Region Name",
	"BAT_ORGANIZED.area_id": "Area Name",
	"BAT_ORGANIZED.city_id": "City Name",
	"shop_data.facia_url": "Facia",
	"outlet_data.ownership_type": "Ownership",
	"shop_details.outlet_types": "Shop Types",
	"shop_data.sub_category": "Sub Category",
	"shop_data.internat_id": "Petra id	",
	"shop_data.shampoo": "Shampoo",
	"shop_data.talcumpowder": "Talcum Powder",
	"shop_data.makeupfacepowderlipstickseyelinernailpolishetc":
		"Makeup (Face Powder / Lipsticks / Eye Liner / Nail Polish etc)",
	"shop_data.hairremovingproductsdepilatoriesiecreamlotionpowderetc":
		"Hair Removing Products (Depilatories) (i.e. Cream / Lotion / Powder etc)",
	"shop_data.sanitarypadsnapkinsfemproducts": "Sanitary Pads / Napkins (Fem products)",
	"shop_data.babydiapers": "Baby Diapers",
	"shop_data.babyproductsieshampoolotionoiletc": "Baby Products (i.e. Shampoo / Lotion / Oil etc.)",
	"shop_data.deodorantsrollonsticksbodyspray": "Deodorants (Roll on / Sticks / Body Spray)",
	"shop_data.shavingcreamfoamgel": "Shaving Cream / Foam / Gel",
	"shop_data.tooth_paste": "Tooth Paste / Powder",
	"shop_data.toothbrush": "Tooth Brush",
	"shop_data.conditioner": "Conditioner",
	"shop_data.handsanitizer": "Hand Sanitizer",
	"shop_data.antisepticpersonal": "Antiseptic Personal",
	"shop_data.greyimportedsoap": "Grey/Imported Soap",
	"shop_data.greyimportedshampooconditioner": "Grey/Imported Shampoo/Conditioner",
	"shop_data.greyimportedskincreamlotion": "Grey/Imported Skin cream/lotion",
	"shop_data.toiletsoap": "Toilet Soap",
	"shop_data.liquidsoaphandwash": "Liquid Soap / Hand Wash",
	"shop_data.skincarecreamslotion": "Skin Care Creams / Lotion",
	"shop_data.liquidfacewash": "Liquid Face Wash",
	"shop_data.liquidbodywash": "Liquid Body Wash",
	"shop_data.haircolorant": "Hair Colorant",
	"shop_data.hairoil": "Hair Oil",
	"outlet_data.new_poi": "New POIs",
	"shop_data.validated": "Validated",
	"shop_data.outlet_type": "Channel Type"
};
const Config = {
	clientDataConfig: tenant => {
		return [...commonClientMarkerFields, ...(extraClientMarkerFields[tenant] || [])];
	},
	censusDataConfig: tenant => {
		return [...commonCensusMarkerFields, tenant, ...(extraCensusMarkerFields[tenant] || [])];
	},
	allClientMarkersVisibility: {
		[ISMAIL_INDUSTRIES]: true
	},
	extraClientMarkerButtons: {
		[BAT_UK_INDEPENDENT]: [
			{
				buttonText: "Assigned",
				key: "outlet_data.ownership_type",
				text: "Assigned",
				filterValue: "Independent Assigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client"
			},
			{
				buttonText: "Unassigned",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client"
			}
		],
		[BAT_TENNESSEE]: [
			{
				buttonText: "Matched TDLinx Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			},
			{
				buttonText: "Temporarily Closed",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		],
		[BAT_SWEDEN]: [
			{
				buttonText: "Matched  Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		],
		[BAT_CROATIA]: [
			{
				buttonText: "Matched  Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
			// {
			// 	buttonText: "Temporarily Closed",
			// 	key: "outlet_data.ownership_type",
			// 	filterValue: "Independent Unssigned",
			// 	text: "Unassigned",
			// 	color: "orange",
			// 	mappedKey: keysMapping["outlet_data.ownership_type"],
			// 	type: "client",
			// 	disabled: true
			// }
		],
		[BAT_MALAYSIA]: [
			{
				buttonText: "Matched  Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		],
		[BAT_TURKEY]: [
			{
				buttonText: "Matched  Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				color: "orange",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		],
		[BAT_FLORIDA]: [
			{
				buttonText: "Matched  Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		],
		[BAT_JAPAN]: [
			{
				buttonText: "Smoking Zones",
				key: "shop_data.smoking_area",
				filterValue: "Yes",
				text: "Yes",
				color: "#FF00FF",
				mappedKey: "shop_data.smoking_area",
				type: "census",
				autoLoadShops: true
			},
			{
				buttonText: "HoReCa",
				key: "shop_data.horeca",
				filterValue: "Yes",
				text: "Yes",
				color: "#0DAF00",
				mappedKey: "shop_data.horeca",
				type: "yellow",
				autoLoadShops: true
			}
		],
		[BAT_GREECE]: [
			{
				buttonText: "Matched  Outlets",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				// color: "orange",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		],
		[BAT_STATES]: [
			{
				buttonText: "Matched  Shops",
				key: "outlet_data.ownership_type",
				filterValue: "Independent Unssigned",
				text: "Unassigned",
				// color: "orange",
				mappedKey: keysMapping["outlet_data.ownership_type"],
				type: "client",
				disabled: true
			}
		]
	},

	SEC: {
		[BAT_UK_INDEPENDENT]: CommonSec,
		[BAT_UK]: CommonSec,
		[BAT_KHI]: CommonSec,
		[PG_PHL]: [...CommonSec, "E"],
		[nielsen_demo]: [...CommonSec, "E"],
		[LOREAL]: [...CommonSec, "E"],
		[BAT_UK_INDEPENDENT]: [...CommonSec, "E"],
		[BAT_ORGANIZED]: CommonSec,
		[BAT_GERMANY]: [...CommonSec, "E"]
	},
	keysMapping
};
export default Config;
const mapCensusTabelData = (dataWithMapping, areaInfo, isClient, tenant) => {
	let extra = !isClient ? extraCensusMarkerFields[tenant] : extraClientMarkerFields[tenant];
	let extraData = {};
	if (!isEmpty(extra)) {
		extra.forEach(key => {
			extraData[keysMapping[key] || key] = dataWithMapping[key];
		});
	}
	const data = isClient
		? {
				[tenant === "BAT_UK_INDEPENDENT" ? "PeTra ID" : "Customer Name"]: dataWithMapping["name"],
				[tenant === "BAT_UK_INDEPENDENT" ? "Customer Name" : "Customer Code"]: dataWithMapping["code"]
		  }
		: {
				"SA Shop Name": dataWithMapping["shop_details.name"],
				"SA Shop ID": dataWithMapping["_id"]
		  };
	return {
		...(![BAT_UK, BAT_UK_INDEPENDENT].includes(tenant) && { "SA Shop ID": dataWithMapping["_id"] }),
		...data,
		...areaInfo,
		...extraData
	};
};
const getPosition = ([lng, lat]) => {
	return {
		lat: parseFloat(lat),
		lng: parseFloat(lng)
	};
};
const mapMarkerData = (dataWithMapping, isClient) => {
	const data = isClient
		? {
				label: dataWithMapping["name"],
				position: getPosition(dataWithMapping["location.coordinates"])
		  }
		: {
				label: dataWithMapping["shop_details.name"],
				position: getPosition(dataWithMapping["shop_details.coordinates"])
		  };
	const id = dataWithMapping["_id"];
	const marker = {
		id,
		...data,
		isPoi: true,
		showInfo: true,
		isClient
	};
	return { id, marker };
};

export { Config, mapCensusTabelData, mapMarkerData, getPosition };
